import {TimeRule} from 'Event/attendee-rules/RuleConfig/RuleList/SingleRule/TimeRule'
import {isFuture, isPast, now as actualNow} from 'lib/date-time'

export function matchesTimeRule(rule: TimeRule, now: string = actualNow()) {
  const isFromMatch = rule.from ? isPast(rule.from, now) : true
  const isToMatch = rule.to ? isFuture(rule.to, now) : true

  return isFromMatch && isToMatch
}
